/** @format */

import React, { useEffect, useState } from 'react';
import { ReceivedDelegationReport } from './ReceivedDelegationReport';
import { CommonProvider } from 'providers';
import { PageContainer } from 'components';
import { useBusiness , useCurrencyUnit} from 'hooks';
import { constBreadCrumbsTitle } from 'utility';
import { getDynamicReportPages } from 'utility';
import ContentOld from './ReceivedDelegation';
const ReceivedDelegationList = () => {
    const reportElement = getDynamicReportPages(['menuDelegation'])
    const businessInfo = useBusiness();
    const [loading, setLoading] = useState(true);
      const currencyText = useCurrencyUnit(false);
    
    const hint = 'در این بخش می‌توانید گزارش وجه‌های تفویض شده از جانب دیگران به خود را مشاهده کنید.';

    useEffect(() => {
        if (businessInfo?.userId) setLoading(false);
    }, [businessInfo]);

    return (
        <PageContainer
            title="وجه‌های تفویض شده به من"
            description={hint}
            pageKey={reportElement['menuDelegation'] ? '' : "receivedDelegation"}
            breadcrumbs={constBreadCrumbsTitle.DELEGATION_ME}
            loading={loading}
        >
            <CommonProvider>
                { // درصورتیکه کلید برگردد ، یعنی کامپوننت جدید را نمایش بدهیم ، در غیراینصورت کامپوننت یا صفحه قدیمی رو برای کاربر نمایش میدهیم
                    reportElement['menuDelegation'] ? (<ReceivedDelegationReport businessInfo={businessInfo} currencyText={currencyText}/>) : (<ContentOld currencyText={currencyText}/>)
                }
            </CommonProvider>
        </PageContainer>
    );
};

export default ReceivedDelegationList;
